//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Analytics from '@/scripts/libs/analytics'
import RbProductTileHeader from '@/elements/product-tile/product-tile-header/product-tile-header.vue'
import RbProductTileContent from '@/elements/product-tile/product-tile-content/product-tile-content.vue'
import RbProductTileFooter from '@/elements/product-tile/product-tile-footer/product-tile-footer.vue'
import RbProductTileImagesContent from '@/elements/product-tile/product-tile-images-content/product-tile-images-content.vue'
import RbProductTileUtils from '@/elements/product-tile/rb-product-tile'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { formatTimeTile, getBestBetweenTwoPromos, sortPromos } from '@/scripts/libs/sort-promos'
import { WcsPromotions } from '@/scripts/libs/wcs/promotions'
import { PROMO_TIMER_TICK, SCARCITY } from '@/scripts/constants/promos'
import { createNamespacedHelpers, mapActions, mapGetters } from 'vuex'
import {
  ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG,
  ACTION_ADD_TO_BAG,
  ACTION_ADD_TO_BAG_REMIX,
} from '@/scripts/store/actions'
import { ACTION_UPDATE_FOCUSED_PRODUCT_TILE } from '@/scripts/store/plp/actions'
import RbDate from '@/utils/rb-date'
import RbProductTileBottomCarousel from '@/elements/product-tile/product-tile-bottom-carousel/product-tile-bottom-carousel.vue'
const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')
const { mapGetters: mapGettersPlp, mapActions: mapActionsPlp } = createNamespacedHelpers('plp')
export default {
  name: 'rb-product-tile',
  components: {
    RbProductTileHeader,
    RbProductTileContent,
    RbProductTileFooter,
    RbProductTileBottomCarousel,
    RbProductTileImagesContent,
  },
  provide() {
    return {
      dataElementId: this.dataElementIdLabel,
      isProductTileEditorial: this.isEditorial,
      isLoading: this.loading,
      getIsTileFocused: () => this.isTileFocused,
      getSelectedVariant: this.selectedVariant,
      isPlpExclusive: this.isPlpExclusive,
      handleWishlistModal: this.handleWishlistModal,
      isFirstTransitionInViewport: this.isFirstTransitionInViewport,
    }
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    index: {
      type: Number,
      required: false,
    },
    isEditorial: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataElementId: {
      type: String,
      default: '',
    },
    dataDescription: {
      type: String,
      default: '',
    },
    addToCart: {
      type: Object,
      default: null,
    },
    addToBagDataElementId: {
      type: String,
      default: '',
    },
    isHoverEffectEnabled: {
      type: Boolean,
      default: true,
    },
    wishlistIconIsVisible: {
      type: Boolean,
      default: true,
    },
    preventLazy: {
      type: Boolean,
      default: false,
    },
    isPlpExclusive: {
      type: Boolean,
      default: false,
    },
    handleWishlistModal: {
      type: Function,
      default: () => null,
    },
    isInsideSearchPanel: {
      type: Boolean,
      default: false,
    },
    isInViewPortPanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIndex: 0,
      hover: false,
      promotionsInterval: undefined,
      currentPromotion: {},
      uniqueId: null,
      firstHover: false,
      isFirstTransitionInViewport: false,
    }
  },
  computed: {
    ...mapGetters(['findInStorePanelIsVisible']),
    ...mapGettersPdp([
      'correlatedProducts',
      'correlatedProductsAvailability',
      'selectedCatEntryId',
      'selectedProduct',
      'cmsDynamicContent',
      'isRoxPanelRendered',
    ]),
    ...mapGettersPlp(['wcagFocusedTileId']),
    showBottomCarousel() {
      return (
        !this.isEditorial &&
        (this.hover || this.isMobile || this.isPlpExclusive || this.isTileFocused)
      )
    },
    upc() {
      return this.selectedVariant?.partNumber
    },
    sku() {
      return this.product?.sku
    },
    canAddHoverClass() {
      if (this.isMobile || this.addToCartAvailable || this.isPlpExclusive) {
        return false
      }
      return this.hover || this.isTileFocused
    },
    isTileFocused() {
      return this.wcagFocusedTileId === this.uniqueId
    },
    dataElementIdLabel() {
      return (
        this.dataElementId ?? `${this.selectedVariant?.name}_${this.selectedVariant?.partNumber}`
      )
    },
    isCustomizable() {
      return this.selectedVariant?.customizable?.length > 0
    },
    dataDescriptionLabel() {
      if (this.dataDescription) {
        return this.dataDescription
      }
      return `${this.selectedVariant?.name}_${this.selectedVariant?.partNumber}`
    },
    addToCartAvailable() {
      return this.addToCart !== null
    },
    colors() {
      return this.product?.colors || []
    },
    attachments() {
      return this.selectedVariant?.attachments || []
    },
    selectedVariant() {
      return (this.colors || [])[this.selectedIndex] || {}
    },
    category() {
      return this.product?.category
    },
    wornImage() {
      if (this.selectedVariant?.hasWornImage && this.isEditorial) {
        return this.selectedVariant?.images?.secondary
      }
      if (this.isPlpExclusive) {
        return RbProductTileUtils.wornImageExclusive(this.selectedVariant?.attachments)
      }
      return RbProductTileUtils.getWornImage(this.selectedVariant?.attachments)
    },
    showHoverImage() {
      return this.hover || (this.isTileFocused && !this.addToCartAvailable)
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    getWornImagePosition() {
      return RbProductTileUtils.getWornImagePosition(this.selectedVariant?.attachments)
    },
    isWornVariant() {
      if (this.selectedVariant?.hasWornImage && this.isEditorial) {
        return this.selectedVariant?.hasWornImage
      }
      return !!RbProductTileUtils.getWornImage(this.selectedVariant?.attachments)
    },
  },
  watch: {
    isInViewPortPanel(nValue) {
      if (this.isMobile && nValue) {
        this.isFirstTransitionInViewport =
          nValue && this.selectedVariant?.isTransition && this.selectedIndex === 0
      } else {
        this.isFirstTransitionInViewport = false
      }
    },
    newsletterSubmitCounter() {
      this.resetPromotionsInterval()
      this.startPromoTimer()
    },
    selectedVariant() {
      this.resetPromotionsInterval()
      this.currentPromotion = this.mapCurrentPromotion({})
      if (this.selectedVariant?.promotions?.length > 0) {
        this.startPromoTimer()
      }
    },
  },
  mounted() {
    this.uniqueId = this._uid
    if (this.selectedVariant?.promotions?.length > 0) {
      this.startPromoTimer()
    }
    if (!this.addToCartAvailable) {
      if (!this.isMobile && this.isHoverEffectEnabled) {
        this.$refs?.tile?.addEventListener('mouseover', this.mouseHoverTile)
        this.$refs?.tile?.addEventListener('mouseleave', this.mouseHoverTile)
      }
    }
  },
  beforeDestroy() {
    this.resetPromotionsInterval()
    if (!this.addToCartAvailable) {
      if (!this.isMobile && this.isHoverEffectEnabled) {
        this.$refs?.tile?.removeEventListener('mouseover', this.mouseHoverTile)
        this.$refs?.tile?.removeEventListener('mouseleave', this.mouseHoverTile)
      }
    }
  },
  methods: {
    ...mapActions({
      dispatchAddToBag: ACTION_ADD_TO_BAG,
      dispatchAddToBagRemix: ACTION_ADD_TO_BAG_REMIX,
      addProductAndCorrelatedToShoppingBag: ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG,
    }),
    ...mapActionsPlp({
      updateFocusedTileId: ACTION_UPDATE_FOCUSED_PRODUCT_TILE,
    }),
    isInView(e) {
      if (!this.isInsideSearchPanel) {
        const ratioInView = this.isPlpExclusive ? 0.5 : 1
        const hasRestrictionIndex = this.isPlpExclusive ? true : this.selectedIndex === 0
        if (this.isMobile && e.type === 'progress' && e.percentInView >= ratioInView) {
          this.isFirstTransitionInViewport =
            this.selectedVariant?.isTransition && hasRestrictionIndex
        }
      }
    },
    async addToBag(selectedVariant) {
      await this.dispatchAddToBag({
        catEntry: selectedVariant.catentryId,
        isFromWishlist: false,
        configurationId: selectedVariant.configurationId,
      })
    },
    onFocus() {
      if (this.addToCartAvailable || !this.isHoverEffectEnabled || this.hover) {
        return
      }

      this.updateFocusedTileId(this.uniqueId)
      if (!this.isPlpExclusive) {
        this.selectIndex(0)
      }
    },
    onClick(ev) {
      if (this.addToCartAvailable) {
        return
      }

      if (
        ev.target.classList.contains('--no-click') ||
        ev.target.parentNode.classList.contains('--no-click')
      ) {
        ev.preventDefault()
        ev.stopPropagation()
        if (ev.target?.dataset?.href) {
          window.location = ev.target?.dataset?.href
        }
      }
      if (!this.isEditorial) {
        Analytics.trackMouseClick(this.selectedVariant)
      }
    },
    mouseHoverTile(ev) {
      const { type } = ev
      this.firstHover = true
      this.hover = type === 'mouseover'
    },
    selectIndex(index) {
      this.selectedIndex = index
    },
    startPromoTimer() {
      const areAllPromotionsOver = sortPromos(this.selectedVariant.promotions).length === 0
      if (areAllPromotionsOver) {
        this.currentPromotion = this.mapCurrentPromotion({})
        return
      }
      this.calculateCurrentPromotion()
      this.promotionsInterval = setInterval(() => {
        this.calculateCurrentPromotion()
      }, PROMO_TIMER_TICK)
    },
    calculateCurrentPromotion() {
      const areAllPromotionsOver = sortPromos(this.selectedVariant.promotions).length === 0
      if (areAllPromotionsOver) {
        clearInterval(this.promotionsInterval)
      }
      let sortedPromotions = sortPromos(this.selectedVariant.promotions)
      let currentPromotion = getBestBetweenTwoPromos(sortedPromotions)
      if (sortPromos(this.selectedVariant.promotions).length === 0) {
        this.currentPromotion = this.mapCurrentPromotion({})
      } else {
        sortedPromotions = sortPromos(this.selectedVariant.promotions)
        currentPromotion = getBestBetweenTwoPromos(sortedPromotions)

        const isPromotionProgress = WcsPromotions.isPromotionInProgress(
          currentPromotion.startDate,
          currentPromotion.endDate
        )
        if (isPromotionProgress) {
          this.currentPromotion = this.mapCurrentPromotion(currentPromotion)
        }

        const isPromoEnded = WcsPromotions.isPromotionEnded(currentPromotion.endDate)
        if (isPromoEnded) {
          this.currentPromotion = {}
        }
      }
    },
    mapCurrentPromotion(promotion) {
      const isScarcity = promotion.type === SCARCITY
      const mappedPromotion = {
        isFlash: isScarcity,
        discountedPrice: promotion.priceLabel,
        badge: promotion?.toggle || promotion?.badge,
      }
      if (isScarcity) {
        const promoRemainingDuration = RbDate.diffInMilliseconds(promotion.endDate)
        const dayLabel = this.$t('common.day')
        const daysLabel = this.$t('common.days')
        const time = formatTimeTile(promoRemainingDuration, dayLabel, daysLabel)
        mappedPromotion.formattedRemainingTime = `${this.$t(
          'common.product_tile.status_message.flash_sale'
        )} | ${time}`
      }
      return mappedPromotion
    },
    resetPromotionsInterval() {
      this.promotionsInterval && clearInterval(this.promotionsInterval)
    },
  },
}
